module.exports = __webpack_public_path__ + "img/close.f1294bc2.svg";